import Lenis from "lenis";

let lenis = null;

export function initLenis() {
  if (lenis) return lenis;
  lenis = new Lenis({ lerp: 0.12, wheelMultiplier: 1.6, touchMultiplier: 1.8 });
  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);
  return lenis;
}

export function scrollToTop() {
  if (lenis) lenis.scrollTo(0, { immediate: true, force: true });
  window.scrollTo(0, 0);
}

export function scrollToId(selector, immediate = false) {
  if (immediate) {
    const el = document.querySelector(selector);
    if (!el) return;
    const top = el.getBoundingClientRect().top + window.scrollY - 64;
    if (lenis) lenis.scrollTo(top, { immediate: true, force: true });
    window.scrollTo(0, top);
    return;
  }
  window.dispatchEvent(new Event("gumz:unlock"));
  if (lenis) {
    lenis.scrollTo(selector, { offset: -64, duration: 1.2 });
  } else {
    document.querySelector(selector)?.scrollIntoView({ behavior: "smooth" });
  }
}
